import React, { Component, Fragment } from 'react'
import TextInput from 'components/UI/TextInput'
import { ContentBlock } from 'components/common'
import { Button } from 'components/UI/Button'
import {
  handleErrorMessageAlert
} from 'components/UI/Alert'
import { ThunkAction } from 'store/types'
import { Form, FormTitle, BottomBlock } from './styles'
import { passwordValidation } from '../../../utils/helpers'

interface State {
  currentPassword: string
  newPassword: string
  showSuccess: boolean
  errors: {
    currentPassword: string
    newPassword: string
  }
}

// tslint:disable-next-line:no-empty-interface
interface Props {
  isProcessing: boolean
  errorMessage: string
  onChangePassword: (
    currentPassword: string,
    newPassword: string
  ) => ThunkAction
}

class ChangePasswordForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      currentPassword: '',
      newPassword: '',
      showSuccess: false,
      errors: {
        currentPassword: '',
        newPassword: ''
      }
    }
  }

  componentDidUpdate = (prevProps: Props) => {
    const isProcessed = prevProps.isProcessing && !this.props.isProcessing
    if (isProcessed && this.props.errorMessage) {
      handleErrorMessageAlert(this.props.errorMessage)
    }
    if (isProcessed && !this.props.errorMessage) {
      this.setState({ showSuccess: true })
    }
  }

  onChange = (name: string, value: string) => {
    this.setState(prevState => ({
      ...prevState,
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: ''
      }
    }))
  }

  onSubmit = () => {
    const errors = this.validate()
    if (isValid(errors)) {
      this.props.onChangePassword(
        this.state.currentPassword,
        this.state.newPassword
      )
    }
  }

  onCancel = () => {
    this.setState({
      currentPassword: '',
      newPassword: ''
    })
  }

  goBack = () => {
    this.setState({
      showSuccess: false,
      currentPassword: '',
      newPassword: ''
    })
  }

  validate = () => {
    const { currentPassword, newPassword } = this.state
    const errors: any = {}
    if (!currentPassword) {
      errors.currentPassword = 'Please enter current password'
    }
    if (passwordValidation(currentPassword)) {
      // currentPassword.length < 8
      errors.password =
        'Please check your password. It must be longer 8 and include upper letters, ' +
        'lower letters, and number' // 'The password length is too small. Please try again.'
    }
    if (!newPassword) {
      errors.newPassword = 'Please enter new password'
    }
    if (passwordValidation(newPassword)) {
      // newPassword.length < 8
      // errors.newPassword =
      //   'The new password length is too small. Please try again.'
      errors.password =
        'Please check your new password. It must be longer 8 and include upper letters, ' +
        'lower letters, and number' // 'The password length is too small. Please try again.'
    }
    this.showAlertErrors(errors)
    this.setState({ errors })
    return errors
  }

  showAlertErrors = (errors: any) => {
    Object.keys(errors).forEach(prop => {
      if (errors[prop]) {
        handleErrorMessageAlert(errors[prop])
      }
    })
  }

  render() {
    const { showSuccess, currentPassword, newPassword, errors } = this.state
    console.log('ERROR_MESSAGE', this.props.errorMessage)
    return (
      <Fragment>
        <ContentBlock>
          <Form>
            <FormTitle>Change Password</FormTitle>
            {showSuccess ? (
              <span>Your password is successfully changed</span>
            ) : (
              <Fragment>
                <TextInput
                  type={'password'}
                  name={'currentPassword'}
                  value={currentPassword}
                  label={'Current Password'}
                  errorLabel={errors.currentPassword || ''}
                  handleChange={this.onChange}
                  tooltipText={'Current Password'}
                />
                <TextInput
                  type={'password'}
                  name={'newPassword'}
                  value={newPassword}
                  label={'New Password'}
                  errorLabel={errors.newPassword || ''}
                  handleChange={this.onChange}
                  tooltipText={'New password'}
                />
              </Fragment>
            )}
          </Form>
        </ContentBlock>

        {showSuccess ? (
          <BottomBlock>
            <Button variant={'default'} onClick={this.goBack}>
              Done
            </Button>
          </BottomBlock>
        ) : (
          <BottomBlock>
            <Button variant={'secondary'} onClick={this.onCancel}>
              Cancel
            </Button>
            <Button
              disabled={this.props.isProcessing}
              variant={'default'}
              onClick={this.onSubmit}
            >
              Change Password
            </Button>
          </BottomBlock>
        )}
      </Fragment>
    )
  }
}

const isValid = (errors: object) => {
  return Object.values(errors).filter((v: string) => v.length > 0).length === 0
}

export default ChangePasswordForm
